import { COURSE_TYPE_TRAINER } from '@/constants/types';
import storage from './storage';

export const DEFAULT_DRAFT = {
    id: 0,
    type: COURSE_TYPE_TRAINER,
    date: null,
    weekdays: [],
    start_time: null,
    end_time: null,
    coach_id: 0,
    trainer_id: 0,
    programs: [],
    program_options: [],
    event: null,
    comment: null,
    comment_publicly: true,
    draft: false,
};

export default {
    programs: null,
    course: null,
    created: null,
    patched: null,
    deleted: null,
    notified: null,
    stats: {},
    draft: { ...DEFAULT_DRAFT, ...storage.getDraft() },
    used_trainers: storage.getUsedTrainers() || [],
};



// WEBPACK FOOTER //
// ./src/store/course/state.js